<script>
import SlideHeader from '@components/slide-header.vue'

export default {
  components: { SlideHeader },
  props: {
    report : {
      type: Object,
      required: true
    },
  	background: {
  		type: Object,
  		required: false,
      default: null
  	},
    index: {
      type: Number,
      required: false,
      default: null
    },
    activeIndex: {
      type: Number,
      required: false,
      default: null
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false
    },
    slide : {
      type: Object,
      required: true
    },
    subslide: {
      type: Number,
      required: false,
      default: null
    }
  },
  data() {
    return {
        hasBeenActive: this.isActive
    }
  },
  computed: {
    style () {
      return this.background? 'background-image: url(' + this.background.url + ')' : '';
    }
  },
  watch: {
    isActive(val) {
        if(!this.hasBeenActive && val === true) {
            this.hasBeenActive = true;
        }
    }
  },
  methods: {
    hasHelpSection(variation = null) {
      return this.$te(this.slide.id + '.help' + (variation? '_' + variation : ''));
    },
    openHelp(variation = null) {
      if(this.hasHelpSection(variation)) {
        this.$emit('modal', this.$t(this.slide.id + '.help' + (variation? '_' + variation : '')));
      }
    },
  }
}
</script>

<template>
	<article :class="['slide', $style.wrapper, isActive ? $style['wrapper--visible'] : null]">
	  <div v-if="background" :class="$style.background" :style="style"></div>
    <div :class="$style.container">
        <SlideHeader
          :is-active="isActive"
          :active-index="activeIndex"
          :title="$t(slide.id + '.title')"
          :has-help="hasHelpSection()"
          :index="index"
          @help="openHelp"
          v-on="$listeners"
        />
        <div :class="[$style.slide, isActive || hasBeenActive ? $style['slide--visible'] : null]">
            <component
              :is="slide.component"
              :is-active="isActive"
              :subslide="subslide"
              :index="index"
              :report="report"
              @help="openHelp"
              v-on="$listeners"
            />
        </div>
    </div>
	</article>
</template>

<style lang="scss" module>
@import '@design';
.wrapper {
	min-width: 100%;
	min-height: 100vh;
  opacity: 0;
  transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out;
}
.wrapper--visible {
    opacity: 1;
}
.background {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    filter: blur(3px) saturate(0.8);
    background-attachment: fixed;
    background-position: center center;
    background-size: cover;
    opacity: 0.06;
}
.container {
  position: relative;
  z-index: 2;
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  padding: ($size-grid-size * 10) ($size-grid-size * 3) ($size-grid-size * 3) ($size-grid-size * 3);
  margin: 0 auto;
  color: $color-text;

  @media screen and (min-width: $size-breakpoint-md) {
    padding: 15vh ($size-grid-size * 3) ($size-grid-size * 7) ($size-grid-size * 3);
  }
}
.slide {
  @media screen and (min-width: $size-breakpoint-md) {
    padding-left: $size-grid-size * 9;
  }
  // opacity: 0;
  // transition: opacity 0.7s ease-in-out, transform 0.7s ease-in-out;
  // transition-delay: 0.2s;
}
.slide--visible {
    //opacity: 1;
}
</style>
